import React, { useEffect } from 'react';
import { useLocation, useNavigate, useRoutes } from 'react-router-dom';
import routes, { defaultPath, signInPath } from './routes';
import './App.scss';
import { ConfigProvider } from 'antd';
import { defaultTheme } from './theme/defaultTheme';
import { Chart as ChartJS, registerables } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';

function App() {
  const element = useRoutes(routes);
  const location = useLocation();
  const navigate = useNavigate();

  ChartJS.register(...registerables, zoomPlugin);

  useEffect(
    function () {
      if (location.pathname === defaultPath) {
        navigate(signInPath);
      }
    },
    [location, navigate],
  );

  return (
    <ConfigProvider theme={defaultTheme}>
      <div id={'App'}>{element}</div>
    </ConfigProvider>
  );
}

export default App;
